import CurriculumsList from './CurriculumsList';

export default CurriculumsList;
